import axios, { AxiosResponse, AxiosError } from 'axios'
import { config } from '@/config'
import {
  ForgotPasswordBody,
  LoginBody,
  PasswordResetTokenBody,
  SignupBody,
  PasswordResetBody,
  TokenResponse,
  RefreshTokenBody
} from '@/types/auth'
import { formatResponse } from './helpers/formatResponse'
import { TCSAPIResponse } from '@/types/types'

export const Auth = {
  login: async (body: LoginBody) => {
    try {
      const response: AxiosResponse<TCSAPIResponse> = await axios({
        method: 'POST',
        url: `${config.apiUrl}/v1/auth/login`,
        headers: {},
        data: body
      })

      return formatResponse<TokenResponse>(response.data, null)

    } catch (error) {
      console.log('Error: ', error instanceof Error ? error.message : error)
      return formatResponse<TokenResponse>(null, error as AxiosError)
    }
  },
  signup: async (body: SignupBody) => {
    try {
      const response: AxiosResponse<TCSAPIResponse> = await axios({
        method: 'POST',
        url: `${config.apiUrl}/v1/auth/signup`,
        headers: {},
        data: body
      })

      return formatResponse<TokenResponse>(response.data, null)

    } catch (error) {
      console.log('Error: ', error instanceof Error ? error.message : error)
      return formatResponse<TokenResponse>(null, error as AxiosError)
    }
  },
  forgotPassword: async (body: ForgotPasswordBody) => {
    try {
      const response: AxiosResponse<TCSAPIResponse> = await axios({
        method: 'POST',
        url: `${config.apiUrl}/v1/auth/forgot-password`,
        headers: {},
        data: body
      })

      return formatResponse(response.data, null)

    } catch (error) {
      console.log('Error: ', error instanceof Error ? error.message : error)
      return formatResponse(null, error as AxiosError)
    }
  },
  validatePasswordResetToken: async (body: PasswordResetTokenBody) => {
    try {
      const response: AxiosResponse<TCSAPIResponse> = await axios({
        method: 'POST',
        url: `${config.apiUrl}/v1/auth/validate-reset-token`,
        headers: {},
        data: body
      })

      return formatResponse(response.data, null)

    } catch (error) {
      console.log('Error: ', error instanceof Error ? error.message : error)
      return formatResponse(null, error as AxiosError)
    }
  },
  resetPassword: async (body: PasswordResetBody) => {
    try {
      const response: AxiosResponse<TCSAPIResponse> = await axios({
        method: 'POST',
        url: `${config.apiUrl}/v1/auth/reset-password`,
        headers: {},
        data: body
      })

      return formatResponse(response.data, null)

    } catch (error) {
      console.log('Error: ', error instanceof Error ? error.message : error)
      return formatResponse(null, error as AxiosError)
    }
  },
  getAccessTokenFromRefreshToken: async (body: RefreshTokenBody) => {
    try {
      const response: AxiosResponse<TCSAPIResponse> = await axios({
        method: 'POST',
        url: `${config.apiUrl}/v1/auth/refresh-token`,
        headers: {},
        data: body
      })
      return formatResponse<TokenResponse>(response.data, null)

    } catch (error) {
      console.log('Error: ', error instanceof Error ? error.message : error)
      return formatResponse<TokenResponse>(null, error as AxiosError)
    }
  },
  logout: async (token: string) => {
    try {
      const response: AxiosResponse<TCSAPIResponse> = await axios({
        method: 'POST',
        url: `${config.apiUrl}/v1/auth/logout`,
        headers: {
          Authorization: `Bearer ${token}`
        },
      })

      return formatResponse(response.data, null)

    } catch (error) {
      console.log('Error: ', error instanceof Error ? error.message : error)
      return formatResponse(null, error as AxiosError)
    }
  }
}
